import React, { useRef } from 'react';

import { useParams } from 'react-router-dom';

import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import { useQueryClient } from '@tanstack/react-query';
import PlacementUpdateMenu from 'src/components/shared/placementUpdateMenu';
import useOpenCloseState from 'src/hooks/useOpenCloseState';
import { getAssociateProfileQueryOptions } from 'src/services/associateProfile/associateProfileQueries';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import { useAppSelector } from 'src/store/store';
import { associatePlacementToPlacementInfo } from 'src/utils/placementDetailUtils';

interface ActionsProps {
  placement: AssociateProfilePlacement;
}

const UpdateActionMenu = ({ placement }: ActionsProps) => {
  const { alias } = useParams();
  const { selectedSite } = useAppSelector((state) => state.sites);
  const queryClient = useQueryClient();
  const updateLinkRef = useRef<HTMLButtonElement>(null);
  const { isOpen: isUpdateMenuOpen, open: openUpdateMenu, close: closeUpdateMenu } = useOpenCloseState();

  const invalidatePlacements = () =>
    queryClient.invalidateQueries({
      queryKey: getAssociateProfileQueryOptions.placements(alias ?? '', selectedSite.id).queryKey,
    });

  return (
    <>
      <Button type="link" ref={updateLinkRef} onClick={openUpdateMenu}>
        Update <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <PlacementUpdateMenu
        isMenuOpen={isUpdateMenuOpen}
        anchorRef={updateLinkRef}
        placement={associatePlacementToPlacementInfo(placement)}
        actions={{
          closeMenu: closeUpdateMenu,
          onStatusUpdateSuccess: invalidatePlacements,
          onTransferSuccess: invalidatePlacements,
        }}
      />
    </>
  );
};

export default UpdateActionMenu;
